import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-graph-error-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './graph-error-state.component.html',
  styleUrl: './graph-error-state.component.scss'
})
export class GraphErrorStateComponent {
  @Input() errorMessage: string = 'Something went wrong!';
  @Input() subMessage: string = 'Please refresh the page or contact support.';
  @Input() showIcon: boolean = true;
  @Input() iconSize: number = 25;
}